<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size sm_size">
            <a href="javascript:" class="ui_close" type="button" @click="btnClose"><span class="sr_only">popup close</span></a>
            <dl class="modal_content"><!-- 200413수정 noline 클래스 삭제 -->
                <dt class="ellipsis">
                    <i>{{ $t('TITLE.DASHBOARD.MAIN.CONTENTS') }}</i>
                    <em class="ico_info">
                        <i class="tooltip fl_btm">
                            {{ $t('MESSAGE.DASHBOARD.CONTENTS.TOOLTIP') }}
                        </i>
                    </em>
                </dt>
                <dd>
                    <div class="choose_wrap">
                        <p class="q_opinion">{{ $t('FIELD.DASHBOARD.DISPLAY.3CONTENTS') }}</p>
                        <ul class="choose_list">
                            <li>
                                <label class="checkbox-wrap">
                                    <input type="checkbox" name="contentsList" value="H" v-model="contentsList" @change="changeCheck($event)">
                                    <i class="check-icon"></i>
                                    <em>{{ $t('FIELD.DASHBOARD.HOT.CONTENTS') }}</em>
                                </label>
                            </li>
                            <!-- ASC 여부에 따른 항목 변경 -->
                            <template v-if="isASCUser">
                                <li>
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" name="contentsList" value="F" v-model="contentsList" @change="changeCheck($event)">
                                        <i class="check-icon"></i>
                                        <em>{{ $t('FIELD.DASHBOARD.FAVORITE.CONTENT') }}</em>
                                    </label>
                                </li>
                                <li>
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" name="contentsList" value="N" v-model="contentsList" @change="changeCheck($event)">
                                        <i class="check-icon"></i>
                                        <em>{{ $t('FIELD.DASHBOARD.NEW.UPDATE.CONTENT') }}</em>
                                    </label>
                                </li>
                                <li>
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" name="contentsList" value="S" v-model="contentsList" @change="changeCheck($event)">
                                        <i class="check-icon"></i>
                                        <em>{{ $t('TITLE.LEFT.MENU.SUPPORT') }}</em>
                                    </label>
                                </li>
                            </template>
                            <template v-else>
                                <li>
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" name="contentsList" value="W" v-model="contentsList" @change="changeCheck($event)">
                                        <i class="check-icon"></i>
                                        <em>{{ $t('FIELD.DASHBOARD.WORKBOARD') }}</em>
                                    </label>
                                </li>
                                <li>
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" name="contentsList" value="S" v-model="contentsList" @change="changeCheck($event)">
                                        <i class="check-icon"></i>
                                        <em>{{ $t('TITLE.LEFT.MENU.SUPPORT') }}</em>
                                    </label>
                                </li>
                                <li>
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" name="contentsList" value="N" v-model="contentsList" @change="changeCheck($event)">
                                        <i class="check-icon"></i>
                                        <em>{{ $t('FIELD.DASHBOARD.NEW.UPDATE.CONTENT') }}</em>
                                    </label>
                                </li>
                            </template>
                        </ul>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_modal_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="btnClose">{{ $t('BUTTON.GLOBAL.CLOSE') }}</a>
                            <a href="javascript:" class="btn_blue" @click="btnApply">( {{ creRtnList().length }} / 3 ) {{ $t('BUTTON.GLOBAL.APPLY') }}</a>
                        </div>
                    </div>  
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                          from 'vue';
import axios                        from 'axios';
import qs                           from 'query-string';
import { mapGetters, mapActions }   from 'vuex';
import _                            from 'lodash';
import $                            from 'jquery';
import api                          from '@/service';
import store                        from '@/vuex/store';
import SDLPagination                from '~~c/control/pagination/Pagination';
import { SDLUtil, StringUtil }      from '@/utils';

export default {
    name: 'ContentsConfigPopup',
    props: {
        contList: { type: Array, default: () => { return ['H', 'W', 'S']; } },
        ascContList: { type: Array, default: () => { return ['H', 'F', 'S']; } },
        rtnFunc: {type: Function }
    },
    data() {
        return {
            isASCUser: false,
            contentsList: [],
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            myPages: 'getMyPages',
            storeParams: 'getParams',
            userCorpCd: 'getCorpCd',
            loginSystem: 'getLoginSystem',
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            deptLevelCd: 'getDeptLevelCd',
        }),
    },
    methods: {
        changeCheck(e) {
            let self = e.target;
            if(this.contentsList.length > 3) {
                this.toastMsg(SDLUtil.getMsgProp('MESSAGE.DASHBOARD.CONFIG.OVER.THREE'));
                this.contentsList.splice(3, 1);
                self.checked = false;
            }
        },
        creRtnList() {
            let rtnList = [];
            for(let i = 0; i < this.contentsList.length; i++) {
                let v = this.contentsList[i];
                rtnList.push({
                    WORK_TYPE: this.isASCUser ? 'ASC_CONT' : 'CONTENT',
                    WORK_KEY: this.contentsList[i],
                    /* contents 영역 그려지는 부분 강제 order */
                    ORDER: v === 'H' ? 0 : ( (v === 'W' || v === 'F') ? 1 : ( v === 'S' ? 2 : 3 ) )
                });
            };

            return _.sortBy(rtnList, [function(o) { return o.ORDER; }]);
        },
        async btnApply() {
            let rtnList = this.creRtnList();
            if(rtnList.length < 3) {
                return this.toastMsg(SDLUtil.getMsgProp('MESSAGE.DASHBOARD.CONFIG.UNDER.THREE'));

            } else {
                let params = {
                    WORK_TYPE: rtnList[0].WORK_TYPE,
                    WORK_KEY_1: rtnList[0].WORK_KEY,
                    WORK_KEY_2: rtnList[1].WORK_KEY,
                    WORK_KEY_3: rtnList[2].WORK_KEY,
                };

                return await axios.post( 
                        `${SDLUtil.API_URL}/basis/main/setMySetting.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    })
                    .then(res => {
                        SDLUtil.showLoadingBar(false);
                        this.rtnFunc( rtnList );
                        this.$emit('close');
                    })
                    .catch(err => {
                        SDLUtil.showLoadingBar(false);
                        SDLUtil.errorAlert(err);
                    });
            }
        },
        btnClose() {
            const diffArr = _.difference(this.contList.map(c => c.WORK_KEY), this.contentsList);
            if(diffArr.length > 0) {
                SDLUtil.confirm({
                    title: 'TITLE.WARNING.TITLE',
                    msg: 'MESSAGE.POPUP.CHANGE.CLOSE',
                    okLabel: 'BUTTON.GLOBAL.OK',
                    onOkEvt: () => { this.$emit('close') },
                })

            } else {
                this.$emit('close');
            }
        },
        toastMsg(msg = "Alert") {
            return Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );
        },
    },
    created() {
        this.isASCUser = (Number(this.deptLevelCd) === 1) ? true : false;
        this.contentsList = this.isASCUser ? this.ascContList.map(c => c.WORK_KEY) : this.contList.map(c => c.WORK_KEY);
    },
    mounted() {
        //
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/dashboard/popup/ContentsConfigPopup.vue